/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Utilities
 */

import type * as React from "react";

/** Gets the display name for a React component.
 * @internal
 */
export const getDisplayName = (component: React.ComponentType<any>): string => {
  if (component.displayName) return component.displayName;
  if (component.name) return component.name;
  return "Component";
};
